module.exports = __webpack_public_path__ + "img/illuexam.2cacbe8b.jpg";